module.exports = __webpack_public_path__ + "static/media/logo-no-results.57902949.png";